export default __webpack_public_path__ + "media/flags/de-ee604894.svg";